import * as Const from "../Const";
import React, {useEffect, useMemo, useRef, useState} from "react";
import L from "leaflet"
import "../Leaflet.Editable.js"
import {calculateAverage} from "../utils/OwnMath";


function OverviewMapParcelEditor( { mapReference, editedParcel, onEditedParcelSaveClicked, onEditedParcelCancelClicked }) {

    const TAG = "M-EDIT";

    const geoFencePolygonRefs = useRef([]);
    const workAreaPolygonRefs = useRef([]);

    const mapRef = useMemo(() => {
        console.log(TAG, "map ref changed");
        return mapReference;
    }, [mapReference]);

    const EditingMode = useMemo(() => {
        return {
            GEO_FENCE: Symbol('GEO_FENCE'),
            WORK_AREA: Symbol('WORK_AREA')
        }
    }, []);

    const [editingMode, setEditingMode] = useState(EditingMode.GEO_FENCE);
    
    // const [editedPolygon, setEditedPolygon] = useState(undefined);


    useEffect(() => {
        const geoFenceOptions = { color: 'red', weight: 2, dashArray: '6,3', editable: true, interactive: true, pane: Const.PANE_NAME_PARCEL_EDITOR_FENCE };
        const workAreaOptions = { color: 'blue', weight: 1.5, dashArray: '6,8', editable: true, interactive: true, pane: Const.PANE_NAME_PARCEL_EDITOR_WORK };

        console.log(TAG, "edited parcel", editedParcel);

        function removePolygons(refs) {
            Object.keys(refs.current).forEach(key => {
                refs.current[key].remove();
                delete refs.current[key];
            });
        }

        if (mapRef.current) {
            removePolygons(geoFencePolygonRefs);
            removePolygons(workAreaPolygonRefs);
            if (editedParcel) {
                // TODO: replace with real work area and geo fence
                const hull = editedParcel['hull'];
                const workAreaPolygon = L.polygon(hull, workAreaOptions);
                workAreaPolygon.addTo(mapRef.current);
                workAreaPolygonRefs.current[editedParcel.field_name] = workAreaPolygon;

                const center = calculateAverage(hull);
                const largerHull = hull.map((c) => [c[0] + (c[0] - center[0]) * 0.2, c[1] + (c[1] - center[1]) * 0.2]);
                const geoFencePolygon = L.polygon(largerHull, geoFenceOptions);
                geoFencePolygon.addTo(mapRef.current);
                geoFencePolygonRefs.current[editedParcel.field_name] = geoFencePolygon;
            }
        }
    }, [mapRef, editedParcel]);


    useEffect(() => {
        if (mapRef.current) {
            if (editedParcel) {
                if (editingMode === EditingMode.GEO_FENCE) {
                    workAreaPolygonRefs.current[editedParcel.field_name].disableEdit();
                    geoFencePolygonRefs.current[editedParcel.field_name].enableEdit();
                } else {
                    geoFencePolygonRefs.current[editedParcel.field_name].disableEdit();
                    workAreaPolygonRefs.current[editedParcel.field_name].enableEdit();
                }
            }
        }
    }, [EditingMode, editedParcel, editingMode, mapRef]);
    

    return(
        <>
            {editedParcel
                ?
                <div className={"position-absolute bottom-0 start-50 translate-middle-x mb-3 align-self-center"} style={{zIndex: Const.PANEL_OVERLAY_Z + 10, maxWidth: "70%"}}>
                    <div className={"card shadow-lg p-3"}>
                        <div className={"card-body"}>
                            <div className={"btn-group"} role="group">
                                <input type={"radio"} className={"btn-check"} name={"options"} id={"option_geo_fence"}
                                       checked={editingMode === EditingMode.GEO_FENCE}
                                       onClick={() => setEditingMode(EditingMode.GEO_FENCE)}
                                       readOnly={true}
                                />
                                <label className={"btn btn-primary"} htmlFor={"option_geo_fence"}>Edit GeoFence</label>

                                <input type={"radio"} className={"btn-check"} name={"options"} id={"option_work_area"}
                                       checked={editingMode === EditingMode.WORK_AREA}
                                       onClick={() => setEditingMode(EditingMode.WORK_AREA)}
                                       readOnly={true}
                                />
                                <label className={"btn btn-primary"} htmlFor={"option_work_area"}>Edit WorkArea</label>
                            </div>
                        </div>
                        <div className={"card-footer"}>
                            <div className={"container-fluid col-12"}>
                                <div className={"row"}>
                                    <div className={"btn btn-outline-secondary col"} onClick={onEditedParcelCancelClicked}>Cancel</div>
                                    <div className={"col-auto"}></div>
                                    <div className={"btn btn-primary col"}><s>Save</s></div>
                                </div>
                            </div>
                        </div>
                        <div>Save Button does nothing yet</div>
                    </div>
                </div>
                : null
            }

            {/*<div className={"position-absolute start-50 top-50 p-4 bg-light"} style={{zIndex: Const.PANEL_OVERLAY_Z + 200}}>Hello</div>*/}
        </>
    );

}


export default OverviewMapParcelEditor;